export  var Global = {
    //url:'http://localhost:81/api',
    //url:'http://172.176.145.53/server_assistance/public/api',
    url:'https://server.lavoroassistance.pe/api',
    // url:'http://localhost/server_assistance/public/api',
    urlAdvertisement:'https://portalclientes.lavoroperu.pe',
    system: 'LA'
    
};